/**
 * The schema's enums, as client-safe runtime values.
 *
 * `pnpm zen3:generate` derives `zen3/enums.ts` from the ZenStack schema: each enum is a literal
 * const plus a same-named union type, and the module has zero imports, so reaching an enum from here
 * costs ~100 bytes in a client bundle. `clientEnums.unit.test.ts` pins that it stays import-free and
 * in step with the schema.
 *
 * ⚠️ **Deliberately a wildcard, and deliberately NOT re-pointed at `zen3/models`.** A hand-written
 * list silently fell six enums behind the generator once already (`ConvoVerbosity` and friends);
 * `export *` cannot drift. `zen3/models` would publish the same enums as `schema.enums.X.values`,
 * which drags the un-tree-shakeable `zen3/schema.ts` (a `new SchemaType()`) into every client bundle
 * — 297 KB per enum, measured. Import enum VALUES from here, model/input TYPES from `./types`.
 */
export * from './zen3/enums';
